import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { Button, Heading, Text } from '@/modules/ui';

import { useSubscriptionUpgradeModal, useTrialModal } from '../../../hooks';
import heroImage from '../assets/trialEndHeader.svg';
import * as felaRules from './TrialEndContent.rules';

export const TrialEndContent = () => {
    const { css } = useFela();
    const { openUpgradeModal } = useSubscriptionUpgradeModal();
    const { closeTrialModal } = useTrialModal();

    return (
        <>
            <img src={heroImage} alt='' className={css(felaRules.heroImage)} />
            <Heading variant='h2' color='foregroundsPrimary'>
                <FormattedMessage id='saas.premiumFeaturesTrialEnd.title' />
            </Heading>

            <Text variant='ParagraphNormalRegular' color='foregroundsTertiary' preserveNewLines>
                <FormattedMessage id='saas.premiumFeaturesTrialEnd.text' />
            </Text>

            <div className={css(felaRules.buttonsContainer)}>
                <Button type='primary' onClick={openUpgradeModal}>
                    <FormattedMessage id='saas.premiumFeaturesTrialEnd.button.primary' />
                </Button>
                <Button type='default' onClick={() => closeTrialModal('end')}>
                    <FormattedMessage id='saas.premiumFeaturesTrialEnd.button.secondary' />
                </Button>
            </div>
        </>
    );
};
